import { z } from 'zod';

/** Data sem hora, formato YYYY-MM-DD (usada em vencimentos). */
export const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'data deve estar no formato YYYY-MM-DD');

/** Timestamp ISO 8601 completo (createdAt/updatedAt/eventos). */
export const isoDateTime = z.string().datetime({ offset: true });

export const id = z.string().min(1);

/** Valor monetário não-negativo (BRL). */
export const money = z.number().nonnegative();

export const photoSchema = z.object({
  /** Chave do objeto no S3 (ou URL completa para placeholders/seed). */
  url: z.string().min(1),
  legenda: z.string().optional(),
  tiradaEm: isoDateTime.optional(),
  tiradaPor: z.string().optional(),
});
export type Photo = z.infer<typeof photoSchema>;

export const timelineEventSchema = z.object({
  evento: z.string().min(1),
  em: isoDateTime,
  por: z.string().optional(),
});
export type TimelineEvent = z.infer<typeof timelineEventSchema>;

export const checklistItemSchema = z.object({
  item: z.string().min(1),
  feito: z.boolean().default(false),
});
export type ChecklistItem = z.infer<typeof checklistItemSchema>;

/** Envelope de resposta paginada. */
export const paginated = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    nextCursor: z.string().optional(),
  });

/** Erro padrão da API. */
export const apiErrorSchema = z.object({
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;
